import { render, staticRenderFns } from "./Tile.vue?vue&type=template&id=813ba2fa&scoped=true&"
import script from "./Tile.vue?vue&type=script&lang=js&"
export * from "./Tile.vue?vue&type=script&lang=js&"
import style0 from "./Tile.vue?vue&type=style&index=0&id=813ba2fa&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "813ba2fa",
  null
  
)

export default component.exports